class ProductETA {
  constructor(variants, sku, ip) {
    this.variants=variants;
    this.sku=sku;
    this.available = ( ip === 'continue' );
    this.quantity=1;
    this.buttonTextStart = "Check ETA";
    this.buttonTextTitle = "This product is on preorder";
    this.buttonTextAvailable = "ETA ";
    this.preordertext = "<p>Orders that contain both preorders and regular products will be shipped when all products are available. At our discretion we may choose to ship part of your order early to ensure you receive it as soon as possible. If you urgently require a product, please contact us beforehand. See <a href='https://shop.goodgames.com.au/pages/preorder-policy' target='_blank' rel='noopener noreferrer'>Preorder Policy</a> for more information.</p>";
    this.buttonTextUnknown = "<span>ETA</span><span id='eta-day'>To Be Confirmed</span>";
    this.predecessorSelector = ".additional-information";      
    this.variantSelector = "form[action^='/cart/add']:first select:visible, .radio-wrapper fieldset, form[action^='/cart/add']:first input[type='radio'], variant-radios fieldset";
    this.quantitySelector = "input[name='quantity']";
    this.variantSelectors = $(document).find(this.variantSelector);
    this.quantityField = $(document).find(this.quantitySelector)[0];
    this.stockInStore = document.getElementById('cnc-container');
    this.getQuantity();
    this.addETAButton();
    this.addEventHandlers();
    this.displayETAButton();
    this.getProductETA();
  }
  getQuantity() {
    (this.quantityField !== undefined) ? this.quantity = this.quantityField.value : this.quantity=1;
  }
  addETAButton() {
    var predecessor = document.querySelector(this.predecessorSelector);
    
    this.etaButton = document.createElement('div');      
    this.etaButton.id='rex-eta';
    this.etaButton.type='div';
    /*this.etaButton.classList = predecessor.classList;*/
    this.etaButton.classList.remove("ajax-submit");
    this.etaButton.style.marginTop = '10px';
    predecessor.after(this.etaButton);

    this.etaButtonTitle = document.createElement('p');
    this.etaButtonTitle.id = "etaTitle";
    this.etaButtonTitle.textContent = this.buttonTextTitle;
    this.etaButtonText = document.createElement('p');
    this.etaButtonText.id = "preOrderDate";

    this.preorderText = document.createElement ('p');
    this.preorderText.classList.add ("preOrderInformation");
    this.preorderText.innerHTML = this.preordertext;

    this.etaButton.appendChild(this.etaButtonTitle);
    this.etaButton.appendChild(this.etaButtonText);
    this.etaButton.appendChild(this.preorderText);

    var parent = this;
    
    parent.etaButton.style.display = 'block';
      

    var url = `/apps/retailexpress/products/eta?sku=${this.sku}&quantity_ordered=${this.quantity}&available_for_preorder=true`;
    
    var etaRequest = new Request(url);

    fetch(etaRequest).then(response => response.json()).then(data => {
      
      
      
      if (data.data.length > 0 ) {
        var eta = new Date(data.data[0].eta);

        if (  eta < new Date() ) {
          parent.etaButtonText.innerHTML = parent.buttonTextUnknown;
        } else {
          parent.etaButtonText.innerHTML = `<span>${parent.buttonTextAvailable}</span><span id="eta-day">${
            new Intl.DateTimeFormat('en-AU', {
              day: 'numeric',
              month: 'long',
              year: 'numeric'
            }).format(eta)
          }</span>`;
          /* THF PREORDER CODE */
                  const month = ["January","February","March","April","May","June","July","August","September","October","November","December"];    
                  var new_dispatched_date = new Date();
                   var cuttoffTime = document.getElementById('cutofftime');
                   var textContent = cuttoffTime.textContent;
                   var shippingtime_text = textContent;
                   var shippingtime_number = Number(shippingtime_text);
                   var dateString = new Intl.DateTimeFormat('en-AU').format(eta) ; // output - 04/08/2023   
                  console.log(dateString);
                   var dateParts = dateString.split("/"); 
                    var dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]); //Fri Aug 04 2023 00:00:00 GMT+0530 (India Standard Time)
                    let preorder_month = month[dateObject.getMonth()];
                    var preorder_fullfilmenttime = document.getElementById('fullfilmenttime');                          
                    document.getElementById("dispatchdate").innerHTML = dateObject.getDate() + '<span class="dispatcheddate">' + preorder_month + '</span>';
                    function getNextBusinessDay_delivery(delivery_date) {  
                        delivery_date = new Date(+delivery_date);
                        do {
                          delivery_date.setDate(delivery_date.getDate() + 1);
                        } while (!(delivery_date.getDay() % 6))
                        return delivery_date; 
                    }
                    var result = new_dispatched_date.setDate(new_dispatched_date.getDate() + shippingtime_number);
                    var getNextBusinessDayDelivery = getNextBusinessDay_delivery(dateObject);
                    const new_shipping_month = month[getNextBusinessDayDelivery.getMonth()];
                    const new_delivered_day_date = getNextBusinessDayDelivery.getDate();
                    document.getElementById("delivereddate").innerHTML = new_delivered_day_date + '<span class="delivereddate">'+new_shipping_month+'</span>';
        }
      } else {
        parent.etaButtonText.innerHTML = parent.buttonTextUnknown;
      }
    });
    
  }
  addEventHandlers() {    
    this.etaButton.addEventListener('click', (event) => {
      this.getProductETA();
    });
    
    for (let i=0; i < this.variantSelectors.length; i++) {      
      this.variantSelectors[i].addEventListener('change', (event) => {
        setTimeout(() => {
          this.currentVariant = this.variants.find(variant => variant.id == this.findGetParameter('variant'));
          this.sku = this.currentVariant?.sku;
          this.available = ( this.currentVariant.inventory_policy === 'continue' );
    	  this.displayETAButton();
        }, 250);
      });
    }
    if ( this.quantityField !== undefined ) {
      this.quantityField.addEventListener('input', (event) => {
        this.getQuantity();
        this.displayETAButton();
        
      });
      this.quantityField.addEventListener('change', (event) => {
        this.getQuantity();
        this.displayETAButton();
      });
    }
  }
  displayETAButton() {
    if ( this.available ) {
      this.etaButtonText.innerHTML = `<span>ETA</span><span id="eta-day"></span>`;
      this.etaButton.style.display = 'block';
      if ( this.stockInStore !== undefined) {
        if (this.stockInStore !== null) {
          this.stockInStore.style.display = 'none';
        }
      	
      }
    } else {
      this.etaButton.style.display = 'none';
      if ( this.stockInStore !== undefined ) {
         if (this.stockInStore !== null) {
        this.stockInStore.style.display = 'block';
         }
      }
    }
  }
  getProductETA(){
    var parent = this;
    
    /*parent.etaButton.style.display = 'none';*/
     if ( parent.etaSpinner !== undefined ) {
    parent.etaSpinner.style.display = 'block'; 
     }

    var url = `/apps/retailexpress/products/eta?sku=${this.sku}&quantity_ordered=${this.quantity}&available_for_preorder=true`;
    
    var etaRequest = new Request(url);

    fetch(etaRequest).then(response => response.json()).then(data => {
      
      parent.etaButton.style.display = 'block';
      /*parent.etaSpinner.style.display = 'none';*/
      
      if (data.data.length > 0 ) {
        var eta = new Date(data.data[0].eta);

        if (  eta < new Date() ) {
          parent.etaButtonText.innerHTML = parent.buttonTextUnknown;
        } else {
          parent.etaButtonText.innerHTML = `<span>${parent.buttonTextAvailable}</span><span id="eta-day">${
            new Intl.DateTimeFormat('en-AU', {
              day: 'numeric',
              month: 'long',
              year: 'numeric'
            }).format(eta)
          }</span>`;
        }
      } else {
        parent.etaButtonText.innerHTML = parent.buttonTextUnknown;
      }
    });
  }
  findGetParameter(parameterName) {
    var result = null,
        tmp = [];
    location.search
    .substr(1)
    .split("&")
    .forEach(function (item) {
      tmp = item.split("=");
      if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
    });
    return result;
  }
}

